import { findScrollableParent } from './utilFunctions.js';

const findClosestIndex = (array, value, first, last) => {
	if (first > last) {
		return -1;
	} else if (first === last) {
		return first;
	} else if (first + 1 === last) {
		const firstDist = Math.abs(array[first] - value);
		const lastDist = Math.abs(array[last] - value);
		return firstDist > lastDist ? last : first;
	} else {
		const middle = Math.floor((first + last) / 2);
		if (value > array[middle]) {
			return findClosestIndex(array, value, middle, last);
		} else {
			return findClosestIndex(array, value, first, middle);
		}
	}
};

const getTopOffset = (ela, elb) =>
	ela.getBoundingClientRect().top - elb.getBoundingClientRect().top;

const getTopOffsetFromParent = (el, pa = null) => {
	pa = pa || el.parentElement;
	return getTopOffset(el, pa);
};

export default () => ({
	scrollableParent: null,
	focusedElement: 0,
	elementYPositions: [],
	elementMarkerYPositions: [],

	scrollProps: {
		['x-init']() {
			this.scrollableParent = findScrollableParent(
				this.$el.parentElement
			);
		},
		['@scroll.window.throttle.100ms.debounce.100ms']() {
			this.focusedElement = findClosestIndex(
				this.elementYPositions,
				this.scrollableParent.scrollTop,
				0,
				this.elementYPositions.length - 1
			);
		},
	},

	updateYPosition(index, el) {
		const topOffset = this.scrollableParent
			? getTopOffset(el, this.scrollableParent)
			: el.offsetTop;
		this.elementYPositions[index] =
			topOffset -
			this.scrollableParent.clientHeight / 2 +
			el.clientHeight / 2;

		let clientTarget = el.querySelector('h2');
		let clientOffset = el.clientHeight / 2;
		if (clientTarget) {
			clientOffset =
				getTopOffsetFromParent(clientTarget) +
				clientTarget.clientHeight / 2;
		}
		this.elementMarkerYPositions[index] = el.offsetTop + clientOffset;
	},

	scrollElementProps: (index) => ({
		['x-init']() {
			this.updateYPosition(index, this.$el);
		},
		['@resize.window.debounce.250ms']() {
			this.updateYPosition(index, this.$el);
		},
		[':class']: "{'opacity-50' : focusedElement !== " + index + '}',
	}),
	pictureChangeAnimations: {
		['x-transition.opacity.duration.400ms']: '',
	},
});
